module.exports = __webpack_public_path__ + "img/Compiler_banner.8f40f3e5.png";